import { useEffect, useState } from "react";

import { SPAIN_ES, FRANCE_FR, PORTUGAL_PT } from "@/config/app-constant";
import fetchPhoneNumberData from "@/hooks/magnolia/fetch-phone-number";
import { getOriginCountryData } from "@/utils/origin-country-data";

import { isHelpOverlayCallNumberBrandImpact } from "./help-overlay.utils";

interface PhoneNumberEntry {
  desktop: string;
  mobile: string;
  name: string;
  default: string;
  "@path": string;
}

export function usePhoneNumbers() {
  const [phoneNumbers, setPhoneNumbers] = useState<PhoneNumberEntry[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!isHelpOverlayCallNumberBrandImpact) return;

        const country = await getOriginCountryData();
        const phoneNumbersResponse = await fetchPhoneNumberData();

        if (!phoneNumbersResponse?.results?.length) {
          setPhoneNumbers([]);
          return;
        }

        const validCountry = [SPAIN_ES, FRANCE_FR, PORTUGAL_PT].includes(
          country ?? ""
        );

        const filteredNumbers = phoneNumbersResponse.results.filter(
          (phoneNumber) => {
            const [, , type, location] = phoneNumber["@path"].split("/");
            return (
              type === "confirmation" &&
              (validCountry ? location === country : location === "DEFAULT")
            );
          }
        );

        setPhoneNumbers(filteredNumbers);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching phone numbers:", error);
        setPhoneNumbers([]);
      }
    };

    fetchData();
  }, []);

  return phoneNumbers;
}
